'use client';

import React, { useState } from 'react';
import { FiLoader } from 'react-icons/fi';
import { PiListMagnifyingGlass } from 'react-icons/pi';

import { Icon } from '@/components/icon/icon';
import { useMetricConfigQuery } from '@/hooks/queries/useMetrics';

import ModalMetricShow from '../_modalMetricShow/modalMetricShow';

type Props = {
  metricId: string;
  metricName: string;
  version: number;
};

export function MetricPeekButton( { metricId, metricName, version }: Props ) {
  const [ isPeeking, setIsPeeking ] = useState( false );

  const { data: metricConfig, isLoading } = useMetricConfigQuery(
    isPeeking ? metricId : undefined,
    isPeeking ? version : undefined
  );

  const handlePeekClick = () => {
    setIsPeeking( true );
  };

  const handleClose = () => {
    setIsPeeking( false );
  };

  return (
    <>
      {
        isLoading ? (
          <Icon
            key={ `metric_loader_${ metricId }` }
            icon={ FiLoader }
          />
        ) : (
          <Icon
            key={ `metric_action_info_${ metricName }` }
            icon={ PiListMagnifyingGlass }
            className='table_actions_item'
            style={ { cursor: 'pointer' } }
            onClick={ handlePeekClick }
            data-testid={ `metric-peek-button-${ metricId }` }
          />
        )
      }
      {
        isPeeking && metricConfig && (
          <ModalMetricShow
            metricConfig={ metricConfig }
            onCloseAction={ handleClose }
          />
        )
      }
    </>
  );
}
